import React from "react";
import styles from "./styles/convert-setting-button.module.scss";
import Image from "next/image";
import CheckBox from "@/components/common/checkbox";

type ConvertSettingButtonProps = {
  title: string;
  image: string;
  value: boolean;
  onChange: (isChecked: boolean) => void;
};

const ConvertSettingButton = ({
  title,
  image,
  value,
  onChange,
}: ConvertSettingButtonProps) => {
  const handleClick = () => {
    onChange(!value);
  };
  return (
    <div
      className={value ? styles.button_selected : styles.button}
      onClick={handleClick}
    >
      <div className={styles.button_container}>
        <Image width={24} height={24} src={image} alt={""} />
        <div className={styles.title}>{title}</div>
      </div>
      <CheckBox isChecked={value} onChange={handleClick} />
    </div>
  );
};

export default ConvertSettingButton;
